import moment from 'moment'
import numeral from 'numeral'

export const purchase = {
    id: '',
    invoiceNo: '',
    date: moment().format('YYYY-MM-DD'),
    isPpn: false,
    supplierId: '',
    supplierName: '',
    total: numeral(0).format('0,0.00'),
    grandTotal: numeral(0).format('0,0.00'),
    remark: '',
    updatedAt: moment().format('YYYY-MM-DD'),
    isDeleted: false,
}

export const purchaseDetail = {
    id: '',
    purchaseId: '',
    productId: '',
    productName: '',
    warehouseId: '',
    warehouseName: '',
    qty: 0,
    price: 0,
}